import React  from 'react'
import { ApolloProvider } from 'react-apollo'
import { client } from '../shared/ApolloClient'
import SmartRates from './SmartRates'

export default class SmartRatesWrapper extends React.Component {
  unhideLoansTable = () => {
    document.getElementById('loans-table').style.display = 'table'
  }
  componentDidCatch() {
    this.unhideLoansTable()
  }
  render() {
    return (
      <ApolloProvider client={client}>
        <SmartRates {...this.props} />
      </ApolloProvider>
    )
  }
}
